module.exports = __webpack_public_path__ + "img/xls.2da3600b.png";